export const SET_ROUNDUPS_TRANSACTIONS = 'SET_ROUNDUPS_TRANSACTIONS';
export const UNSET_ROUNDUPS_TRANSACTIONS = 'UNSET_ROUNDUPS_TRANSACTIONS';
export const SET_PAYMENTS = 'SET_PAYMENTS';
export const UNSET_PAYMENTS = 'UNSET_PAYMENTS';
export const SET_CONTRIBUTE_NOW_TRANSACTIONS = 'SET_CONTRIBUTE_NOW_TRANSACTIONS';
export const UNSET_CONTRIBUTE_NOW_TRANSACTIONS = 'UNSET_CONTRIBUTE_NOW_TRANSACTIONS';
export const SET_CONTRIBUTE_NOW_TOTALS = 'SET_CONTRIBUTE_NOW_TOTALS';
export const SET_ROUND_UPS_TOTALS = 'SET_ROUND_UPS_TOTALS';
export const RESET_TO_INITIAL = 'RESET_TO_INITIAL';